





































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ConfirmedAction extends Vue {
  
  firstStep:boolean = true;
  enteredEntityId:string = '';
  
  @Prop({ default: '',  type: String}) entityId!:string;
  @Prop({ default: '',  type: String}) infoText!:string;
  @Prop({ default: '',  type: String}) buttonLabel!:string;
  @Prop({ default: '',  type: String}) buttonIcon!:string;

  @Prop({ default: '',  type: String}) confirmText!:string;
  @Prop({ default: '',  type: String}) confirmHelp!:string;

  @Prop({ default: '',  type: String}) successMessage!:string;
  @Prop({ default: '',  type: String}) errorMessage!:string;

  @Prop({ default: false,  type: Boolean}) skipFirstStep!:boolean;

  raiseEvent() {
    this.$emit('action-confirmed', this.entityId);
  }

  cancelEvent() {
    this.firstStep = true;
    this.$emit('action-cancelled', this.entityId);
  }
}
